module.exports = __webpack_public_path__ + "img/objects-align-bottom.006978f7.svg";